export default "__VITE_ASSET__99239d08__"